import * as types from "../../../Client/redux/actions/actionTypes";
import initialState from "../../../Client/redux/reducers/initialState";
import { CurrentMentorsActions } from "../../../Client/redux/actions/currentClientActions";
import { NotificationActions } from "../Actions/notificationActions";
import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";
import { NotificationInfo } from "../../sharedTypes";
import * as LSTypes from "../../../LiveSwitch/liveSwitchActionTypes";
import { ExternalObserverActions } from "../../../ExternalObserverClient/redux/actions/externalObserverActions";

// type actions = CurrentMentorsActions & LiveSwitchAction
export default function notificationsReducer(
    state = initialState.notifications,
    action: CurrentMentorsActions | LiveSwitchAction | NotificationActions | ExternalObserverActions
): NotificationInfo[] {
    switch (action.type) {
        case LSTypes.PHOTO_REQUEST_RECEIVED:
        case types.REQUEST_PHOTO: {
            return [
                ...state,
                {
                    message: action.localizedNotificationMessage,
                    key: new Date().getTime() + Math.random(),
                    options: {
                        variant: "info",
                    },
                },
            ];
        }
        case LSTypes.RECEIVE_CHAT: {
            return [
                ...state,
                {
                    message: action.localizedNotificationMessage,
                    key: new Date().getTime() + Math.random(),
                    options: {
                        variant: "info",
                    },
                },
            ];
        }
        case types.SAVE_FEEDBACK_OPTIMISTIC_COMPLETE: {
            return [
                ...state,
                {
                    message: action.localizedNotificationMessage,
                    key: new Date().getTime() + Math.random(),
                    options: {
                        variant: "info",
                    },
                },
            ];
        }
        case types.ENQUEUE_SNACKBAR:
            return [...state, action.notification];

        case types.CLOSE_SNACKBAR:
            return state.map((notification) =>
                action.dismissAll || notification.key === action.key
                    ? { ...notification, dismissed: true }
                    : { ...notification }
            );

        case types.REMOVE_SNACKBAR:
            return state.filter((notification) => notification.key !== action.key);

        default:
            return state;
    }
}
